import { FileAddOutlined, FileUnknownOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { ContentWrapper, Icon, ManualItem } from "components";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { delayedDispatch, setBreadcrumb, setLoader, setTitle, updateCrumb } from "store/actions";
import { API, Endpoints } from "utils/api";
import { Ethic, Props, State } from "./types";
import Strings from "utils/strings";
import { push } from "connected-react-router";
import "./styles.scss";

class Ethics extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			ethics: []
		};
	}

	componentDidMount(): void {
		const { dispatch } = this.props;

		dispatch(setTitle(""));

		this.getEthics();
		this.breadcrumb();
	}

	componentDidUpdate(): void {
		const { dispatch } = this.props;
		dispatch(updateCrumb());
	}

	async getEthics() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.get({
				url: Endpoints.uriManuals(),
				params: { type: "ethics" }
			});

			if (response?.ok) {
				const ethics: Ethic[] = response.data.results.ethics || [];
				this.setState({ ethics });
			}
		} catch (err) {
			console.log(err);
		}

		dispatch(setLoader(false));
	}

	async deleteEthic(id: string) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.delete({
				url: Endpoints.uriManuals(id)
			});

			if (response.ok) {
				await this.getEthics();

				notification.success({
					message: Strings.settings.ethics,
					description: response?.data?.message || Strings.settings.fileDeleted,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.settings.ethics,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err: unknown) {
			notification.error({
				message: Strings.serverErrors.title,
				description: err as string,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	breadcrumb() {
		delayedDispatch(
			setBreadcrumb(() => {
				return {
					locations: [
						{
							text: Strings.sidebar.settings,
							route: "/settings",
							icon: "preferences"
						},
						{
							text: Strings.settings.ethics,
							icon: <FileUnknownOutlined translate={null} />,
							iconType: "antd"
						}
					]
				};
			})
		);
	}

	renderList() {
		const { ethics = [] } = this.state;
		const { dispatch } = this.props;

		return (
			<ContentWrapper>
				<div className="ScreenHeader --multi">
					<div className="ScreenHeaderLeft">
						<Icon name="duplicate" />
						<h2>{Strings.settings.ethicsFullTitle}</h2>
					</div>
					<div className="ScreenHeaderRight">
						<button className="EthicAddButton" onClick={() => dispatch(push("/settings/ethics/new"))}>
							<FileAddOutlined translate={null} />
							<p>{Strings.settings.addFile}</p>
						</button>
					</div>
				</div>
				<div className="EthicGrid">
					{ethics.map((ethic) => {
						return <ManualItem {...ethic} key={ethic._id} isEthic onDelete={() => this.deleteEthic(ethic._id!)} />;
					})}
				</div>
				{ethics.length === 0 && (
					<div className="EthicHeader">
						<h3>{Strings.settings.noEthics}</h3>
					</div>
				)}
			</ContentWrapper>
		);
	}

	render() {
		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.settings.ethics}</title>
					<meta name="description" content={Strings.settings.ethicsSubTitle} />
				</Helmet>
				{this.renderList()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(Ethics);
